import React from "react";
import {Card, CardActionArea, CardContent, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

export default function ServiceCard({service, onSelect, selected = false, showBuffers = false, disabled = false}) {
    const {t} = useTranslation();
    return (
        <Card
            variant="outlined"
            sx={{mb: 1, borderColor: selected ? 'primary.main' : undefined}}
        >
            <CardActionArea disabled={disabled} onClick={() => onSelect?.(service)}>
                <CardContent sx={{textAlign: 'left'}}>
                    <Typography variant="subtitle1" fontWeight={600}>{service.name}</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {service.durationMinutes} {t('minutes')} • €{service.price}
                    </Typography>
                    {service.description && (
                        <Typography variant="body2" sx={{mt: 0.5}}>{service.description}</Typography>
                    )}
                    {(showBuffers && (service.bufferBeforeMinutes || service.bufferAfterMinutes)) && (
                        <Typography variant="caption" color="text.secondary" sx={{display: 'block', mt: 0.5}}>
                            {service.bufferBeforeMinutes ? t('preparationBufferMinutes', {minutes: service.bufferBeforeMinutes}) : ''}
                            {service.bufferBeforeMinutes && service.bufferAfterMinutes ? ' • ' : ''}
                            {service.bufferAfterMinutes ? t('aftercareBufferMinutes', {minutes: service.bufferAfterMinutes}) : ''}
                        </Typography>
                    )}
                </CardContent>
            </CardActionArea>
        </Card>
    );
}
